export { ContactForm } from './modules/ContactForm';
export { SmoothScrolling } from './modules/SmoothScrolling';
export { Video } from './modules/Video';
export { Popup } from './modules/Popup';
export { Mmenu } from './modules/Mmenu';
export { Map } from './modules/Map';
export { Slider } from './modules/Slider';
export { Fancybox } from './modules/Fancybox';



// WEBPACK FOOTER //
// ./app/src/js/modules.js